// extracted by mini-css-extract-plugin
export default {"Title":"SignUpNichesStep_Title__+KR8xPln","Niches":"SignUpNichesStep_Niches__LOYpt1sF"};